import React from 'react';
import {render} from 'react-dom';
import {LoginError, LoginErrorProps} from './LoginError';
import {SPAError, LoginErrorTypes} from './loginErrorTypes';

export const showError = ({error, userReadableDescription, debugInfo}: LoginErrorProps): void => {
    const mainEl = document.querySelector('#app-main');
    if (mainEl) {
        render(
            <LoginError error={error} userReadableDescription={userReadableDescription} debugInfo={debugInfo} />,
            mainEl,
        );
    }
};

const defaultErrorHandler = (error: LoginErrorTypes, debugInfo: Record<string, string>) => ({
    error,
    debugInfo,
    userReadableDescription: <>
        There was a problem logging in to your account.
        Please return to the login page.
        If this issue persists, <a href="https://sinclairdigital.atlassian.net/servicedesk/customer/portal/2" target="_blank" rel="noreferrer">contact Storyline Support</a>.
    </>,
});

// customizes the user readable message for certain errors
const LoginErrorHandlers = {
    [SPAError.no_available_targets]: (error, debugInfo) => ({
        error,
        debugInfo,
        userReadableDescription: <>Please <a href="https://sinclairdigital.atlassian.net/servicedesk/customer/portal/2" target="_blank" rel="noreferrer">contact the support team</a> to activate your account.</>,
    }),
};

export const showErrorWithCode = (error: LoginErrorTypes, debugInfo: Record<string, string>): void => {
    const errorHandlerProps = LoginErrorHandlers[error] || defaultErrorHandler;
    showError(errorHandlerProps(error, debugInfo));
};
